/**
 * METODOLOGÍA · «ENTRENAMIENTO REAL PARA UN DESARROLLO INTEGRAL»
 * =============================================================================
 * La fotografía a pantalla completa con el texto encima. Debajo, la tira de los
 * cuatro pilares y el sistema híbrido.
 */

import { CONFIG } from '../config';
import { PantallaCompleta } from '../componentes/PantallaCompleta';
import { Icono, IconoEnAro, type NombreIcono } from '../componentes/Iconos';
import { Revelar } from '../componentes/Piezas';
import { useIdioma } from '../i18n/useIdioma';

export function Metodologia() {
  const { textos } = useIdioma();
  const t = textos.metodologia;

  const irA = (id: string) =>
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <>
      <PantallaCompleta
        id="metodologia"
        foto={CONFIG.fotos.portadaMetodologia}
        alt={t.fotoAlt}
        etiqueta={t.etiqueta}
        tituloMedio
        titulo={
          <>
            {t.titulo1}
            <br />
            <span className="oro">{t.titulo2}</span>
          </>
        }
        texto={t.texto}
        encuadre="50% 24%"
        encuadreMovil="50% 16%"
      >
        <div className="acciones-fila">
          <button type="button" className="boton boton--marco" onClick={() => irA('programas')}>
            <span>{t.boton}</span>
            <Icono nombre="flecha" tam={16} />
          </button>
        </div>
      </PantallaCompleta>

      <div className="caja">
        <Revelar>
          <div className="tira-iconos">
            {t.pilares.map((p) => (
              <div className="tira-iconos__item" key={p.titulo}>
                <IconoEnAro nombre={p.icono as NombreIcono} tam={54} grosorIcono={22} />
                <span className="tira-iconos__texto">{p.titulo}</span>
              </div>
            ))}
          </div>
        </Revelar>

        <Revelar>
          <div className="hibrido">
            <div className="hibrido__titulo">
              <h3 className="mision-vision__titulo">
                {t.sistema1}
                <br />
                {t.sistema2} <span className="oro">{t.sistema3}</span>
              </h3>
              <p className="mision-vision__texto">{t.sistemaTexto}</p>
            </div>

            <ul className="hibrido__lista">
              {t.sistemaPuntos.map((p) => (
                <li className="hibrido__punto" key={p.titulo}>
                  <IconoEnAro nombre={p.icono as NombreIcono} tam={46} grosorIcono={20} />
                  <div>
                    <p className="hibrido__punto-titulo">{p.titulo}</p>
                    <p className="hibrido__punto-texto">{p.texto}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </Revelar>
      </div>
    </>
  );
}
